import React, { useEffect, useState } from 'react'
import BackButton from '../components/BackButton'
import left from '../assets/left.png'
import { decryptData } from '../Script'
import { AddVideo, UpdateAnalytics } from '../Firebase'
import { useNavigate } from "react-router-dom";
import ChooseVoice from '../components/ChooseVoice'
import 'swiper/css';
import Axios from "axios";



export default function CreateVideo() {
    const navigate = useNavigate();


    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedVoice, setSelectedVoice] = useState(null);
    const [titleInput, setTitle] = useState("");
    const [prompt, setPrompt] = useState("");
    const [selectedPill, setSelectedPill] = useState(null);
    const [isLoading, setLoading] = useState(false)
    const [talkingphotoid, setTalkingphotoid] = useState("")

    const [alertMessaeg, setAlertMessage] = useState("")
    const [alertType, setAlertType] = useState("")
    const [isAlertOpen, setIsAlertOpen] = useState("")

    const [userData, setUserData] = useState()




    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const string = urlParams.get('item');

    let item = null; // Default to null

    if (string) {
        try {
            item = decryptData(string); // Decrypt safely
        } catch (error) {
            console.error("Error decrypting item:", error);
            item = null; // Ensure item doesn't break the app
        }
    }

    const type = urlParams.get('type');



    const pills = ['Excited', 'Friendly', 'Serious', 'Soothing', 'Broadcaster'];

    const handleSelectPill = (pill) => {
        setSelectedPill(pill);
        console.log(pill)
    }

    const maxWords = 10;

    const handleInputChange = (e) => {
        const words = e.target.value.split(/\s+/).filter(word => word !== ""); // Remove empty words
        if (words.length > maxWords) {
            e.preventDefault(); // Prevent input beyond limit
            return;
        }
        setPrompt(e.target.value);
    };

    const handleTitleChange = (e) => {
        setTitle(e.target.value);
    };

    const closeAlert = () => {
        setIsAlertOpen("");
    };


    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };



    const handleVoiceSelection = (voiceId) => {
        if (voiceId) {
            console.log("Selected Voice ID:", voiceId);
            setSelectedVoice(voiceId);
            setIsModalOpen(false);
        } else {
            console.warn("No voice selected.");
        }
    };


    async function GenerateVideo() {


        if (type === "streaming" && userData.streaming_limit === 0) {
            setAlertMessage("You have reached your streaming limit.")
            setAlertType("danger")
            setIsAlertOpen("show")
        }

        else if (type === "talking_photo" && userData.talking_photo_limit === 0) {
            setAlertMessage("You have reached your Talking photos limit")
            setAlertType("danger")
            setIsAlertOpen("show")

        }
        else if (type === "avatar" && userData.avatar_limit === 0) {
            setAlertMessage("You have reached your avatars limit.")
            setAlertType("danger")
            setIsAlertOpen("show")
        } else {
            const voice_id = selectedVoice.voice_id;
            const imageId = item.id;
            const title = titleInput;
            const messageprompt = prompt;
            const emotion = selectedPill; // Note: `emotion` is defined but not used in the body.


            if (type != "streaming") {
                try {
                    setLoading(true)

                    const body = {
                        title: title,
                        video_inputs: [
                            {
                                character: {
                                    type: type,
                                    scale: 1.0,
                                    ...(type === "avatar" && { avatar_id: item.avatar_id }),
                                    ...(type === "talking_photo" && { talking_photo_id: imageId }),
                                },
                                voice: {
                                    type: "text",
                                    input_text: messageprompt,
                                    voice_id: voice_id,
                                    emotion: emotion,
                                },
                            },
                        ],
                        test: false,
                        callback_id: null,
                        dimension: {
                            width: 1280,
                            height: 720,
                        },
                        aspect_ratio: null,
                    };

                    const response = await Axios.post(
                        "https://api.heygen.com/v2/video/generate",
                        body,
                        {
                            headers: {
                                "x-api-key": process.env.REACT_APP_X_KEY,
                            },
                        }
                    );

                    console.log("Request Body:", body);
                    console.log("Response:", response.data);
                    const video_id = response.data.data.video_id

                    const message = await AddVideo(type, video_id, title)

                    setAlertMessage(message)
                    setAlertType("success")
                    setIsAlertOpen("show")

                    UpdateAnalytics(type)

                    navigate('/Portal/history', { state: { selectedPill: type } }); // Change 'avatar' to any pill

                    setLoading(false)

                } catch (error) {
                    setLoading(false)
                    console.error("Error generating video:", error);
                }
            } else {
                navigate("/Portal/livestreaming", {
                    state: {
                        voiceID: voice_id,
                        avatarID: item.avatar_id
                    }
                });
            }



        }



    }


    useEffect(() => {
        const session = JSON.parse(sessionStorage.getItem("AI_UserData"))
        setUserData(session)
    }, [])



    return (
        <>
            <div className='container pt-4 p-0' style={{ height: '100vh' }} >
                <BackButton title="Create Video" />

                {isAlertOpen ?
                    <div className={`alert alert-${alertType} alert-dismissible fade show`} data-aos='fade-right' role="alert">
                        <h3>{alertMessaeg}</h3>
                        <button type="button" class="btn-close" aria-label="Close" onClick={() => closeAlert()}></button>
                    </div> : ""}


                {(() => {
                    switch (type) {

                        case 'talking_photo':
                            return (
                                <div>
                                    <h2>Talking Photo</h2>
                                    <img
                                        className='small-image'
                                        src={item.image_url}
                                        style={{ objectFit: 'cover' }}
                                        alt='Talking Photo'
                                    />
                                </div>
                            );

                        case 'avatar':
                            return (
                                <div>
                                    <h2>Avatars</h2>

                                    <img
                                        className='small-image'
                                        src={item.preview_image_url}
                                        style={{ objectFit: 'cover' }}
                                        alt='Avatar'
                                    />
                                </div>
                            );


                        case 'streaming':
                            return (
                                <div>
                                    <h2>Streaming</h2>

                                    <img
                                        className='small-image'
                                        src={item.preview_image_url}
                                        style={{ objectFit: 'cover' }}
                                        alt='Avatar'
                                    />
                                </div>
                            );
                        default:
                            return null;
                    }
                })()}



                <div className='mt-3' >
                    <h2 className='bold'>Voice</h2>

                    {selectedVoice ? (
                        <h2 className='fake-input d-flex flex-row  align-items-center gap-4 p-3'
                            onClick={showModal}>
                            <img className='circle-image'
                                src={require(`../assets/${selectedVoice.name}.png`)}
                                alt="Voice Avatar" />
                            {selectedVoice.name}
                        </h2>
                    ) : (<p className='fake-input d-flex flex-row justify-content-between align-items-center'
                        onClick={showModal}>
                        Select Voice
                        <img style={{ rotate: '180deg' }} src={left} />
                    </p>)}




                </div>


                {type !== "streaming" ? (
                    <div>
                        {/* Title Section */}
                        <div className="mt-3">
                            <h2 className="bold">Title</h2>
                            <input
                                id="titleInput"
                                onChange={handleTitleChange}
                                placeholder="Enter Title"
                            />
                        </div>

                        {/* Prompt Section */}
                        <div className="mt-3">
                            <h2 className="bold">Prompt</h2>
                            <textarea
                                id="promptInput"
                                placeholder="Enter your message"
                                value={prompt} // Ensure controlled component
                                onChange={handleInputChange}
                                className="fake-input"
                            />
                            <p
                                id="wordCount"
                                style={{
                                    textAlign: "right",
                                    color: prompt?.split(/\s+/).filter(word => word !== "").length > maxWords ? "red" : "black"
                                }}
                            >
                                {prompt?.split(/\s+/).filter(word => word !== "").length || 0}/{maxWords}
                            </p>
                        </div>

                        {/* Emotions Section */}
                        <div className="mt-3">
                            <h2 className="bold">Emotions</h2>
                            <div className="pills-div">
                                {pills.length > 0 ? (
                                    pills.map((pill, index) => (
                                        <span
                                            key={index}
                                            className={`pill ${selectedPill === pill ? "selected" : ""}`}
                                            onClick={() => handleSelectPill(pill)}
                                        >
                                            {pill}
                                        </span>
                                    ))
                                ) : (
                                    ""
                                )}
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}



                <button
                    className={`main-button mt-4 ${isLoading ? 'cursor-not-allowed opacity-50' : ''}`}
                    onClick={!isLoading ? GenerateVideo : null}
                    disabled={isLoading}
                >
                    {isLoading ? (
                        <div className="flex items-center space-x-2">
                            <span className="loader"></span> {/* Add a spinner or loader */}
                            <h2>Generating ...</h2>
                        </div>
                    ) : type === "streaming" ? (
                        <h2 className="streaming-header">Start Streaming</h2>
                    ) : (
                        <h2 className="video-header">Generate Video</h2>
                    )}
                </button>



            </div>

            {isModalOpen ?

                <div className='modal-div'  >
                    <div className='bottom-modal ' data-aos='fade-up' >
                        <h2 className='pr-4 pt-4' style={{ textAlign: 'right', cursor: 'pointer' }}
                            onClick={handleCancel}
                        >✖</h2>
                        <ChooseVoice onVoiceSelected={handleVoiceSelection} />

                    </div>
                </div>

                : ""}
        </>
    )
}
